import styled from '@emotion/styled';

export const PriceRow = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr) auto;
  column-gap: 16px;
`;
